import angular from "angular";

import {
    CashdrawerPaymentDialog
} from "../dialog/cashdrawer-payment-dialog/cashdrawer-payment-dialog";

import {
    CimaCashdrawerDriver
} from "./cima-cashdrawer-driver";

import {
    DigitalPaymentHandler,
    DigitalPaymentHandlerOptions,
    DigitalPaymentHandlerResult
} from "src/app/shared/model/digital-payments.model";

import {
    PaymentMethods,
    SalesPayments
} from "tilby-models";

class CimaCashdrawer implements DigitalPaymentHandler {
    static $inject = [
        "$filter",
        "$translate",
        "CashdrawerPaymentDialog",
        "CimaCashdrawerDriver"
    ];

    constructor(
        private $filter: any,
        private $translate: any,
        private CashdrawerPaymentDialog: CashdrawerPaymentDialog,
        private CimaCashdrawerDriver: CimaCashdrawerDriver
    ) {
    }

    public getPaymentReceipt(paymentMethod: SalesPayments): string {
        if(!paymentMethod.payment_data) {
            return "";
        }

        const transaction = JSON.parse(paymentMethod.payment_data);

        const receiptTail = [
            "",
            "Dettaglio pagamento",
            `Da pagare ${this.$filter('sclCurrency')(transaction.toPay).padStart(22, ' ')}`,
            `Pagato ${this.$filter('sclCurrency')(transaction.paid).padStart(25, ' ')}`,
            `Resto erogato ${this.$filter('sclCurrency')(transaction.changeGiven).padStart(18, ' ')}`,
            `Resto non erogato ${this.$filter('sclCurrency')(transaction.changeNotGiven).padStart(14, ' ')}`,
        ];

        return receiptTail.join('\n');
    }

    public async payment(amount: number, options: DigitalPaymentHandlerOptions): Promise<DigitalPaymentHandlerResult> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.schema_name) {
            throw this.$translate.instant('DIGITAL_PAYMENTS.COMMON.SCHEMA_NAME_NOT_FOUND');
        }

        return this.CashdrawerPaymentDialog.show(amount, paymentMethod, this.CimaCashdrawerDriver, "Cassetto Cima");
    }

    public deposit(amount: number, options: { paymentMethod: PaymentMethods; }): Promise<DigitalPaymentHandlerResult> {
        const paymentMethod = options.paymentMethod;

        if (!paymentMethod.schema_name) {
            throw this.$translate.instant('DIGITAL_PAYMENTS.COMMON.SCHEMA_NAME_NOT_FOUND');
        }

        return this.CashdrawerPaymentDialog.show(amount, paymentMethod, this.CimaCashdrawerDriver, "Cassetto Cima", 'DEPOSIT');
    }
}

angular.module('digitalPayments').service('CimaCashdrawer', CimaCashdrawer);
